import { Box, Divider } from "@mui/material"
import DiseaseItem from "./DiseaseItem"
import { MAX_DISEASES } from "config/constants"

const Diseases = ({ data }) => {
  const filteredDiseases = data.sort((a, b) => b.match - a.match).slice(0, MAX_DISEASES)

  return filteredDiseases.map((disease, i) => (
    <Box key={i}>
      <DiseaseItem item={disease} />
      {i !== filteredDiseases.length - 1 && <Divider />}
    </Box>
  ))
}

export default Diseases
